import { CommonModule } from '@angular/common';
import { Component, DoCheck, EventEmitter, NgModule, OnInit, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { CompactBirthdaysModule } from '@app/components/compact-birthdays/compact-birthdays.component';
import { CompactRestaurantMenuModule } from '@app/components/compact-restaurant-menu/compact-restaurant-menu.component';
import { CompactRssFeedsModule } from '@app/components/compact-rss-feeds/compact-rss-feeds.component';
import { CompactUpcomingEventsModule } from '@app/components/compact-upcoming-events/compact-upcoming-events.component';
import { TextPlaceholderModule } from '@app/components/text-placeholder/text-placeholder.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-compact-layout',
  templateUrl: './compact-layout.component.html',
  styleUrls: ['./compact-layout.component.scss']
})
export class CompactLayoutComponent implements OnInit, DoCheck {

  panelOpenState = false;
  hideRssComponent = false;
  hideResturantMenuComponent = false;
  hideBirthdaysComponent = false;
  hideEventsComponent = false;
  @Output() hideCompactSection = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {

  }

  ngDoCheck(): void {
    if (this.hideRssComponent && this.hideResturantMenuComponent && this.hideBirthdaysComponent && this.hideEventsComponent) {
      this.hideCompactSection.emit(true);
    } else {
      this.hideCompactSection.emit(false);
    }
  }

  hideRssFeed(event) {
    this.hideRssComponent = event;

  }

  hideRestaurantMenu(event) {
    this.hideResturantMenuComponent = event;

  }

  hideBirthdays(event) {
    this.hideBirthdaysComponent = event;

  }

  hideEvents(event) {
    this.hideEventsComponent = event;

  }

}

@NgModule({
  declarations: [CompactLayoutComponent],
  exports: [CompactLayoutComponent],
  imports: [
    CommonModule,
    ActionLinkModule,
    TextPlaceholderModule,
    WidgetPlaceholderModule,
    LinkModule,
    CompactUpcomingEventsModule,
    CompactRssFeedsModule,
    CompactRestaurantMenuModule,
    CompactBirthdaysModule,
    MatExpansionModule,
    HideParentIfEmptyModule
  ]
})
export class CompactLayoutModule { }
